"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPreOrderHeaderComponent = void 0;
const core_1 = require("@angular/core");
const constants = require("../../../util/constants");
class CSPreOrderHeaderComponent {
    constructor() {
        this.paymentMethod = constants.paymentMethod;
        this.cancelPreorderEmitter = new core_1.EventEmitter();
        this.editPaymentEmitter = new core_1.EventEmitter();
    }
    /**
     * @returns card type
     */
    getSICardType(content) {
        const re = {
            Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            Master: /^[52][0-9]{15}$/,
            Amex: /^3[0-9]{14}$/,
            Discover: /^6[0-9]{15}$/,
        };
        for (const key in re) {
            if (re[key].test(content)) {
                return key;
            }
        }
    }
    cancelPreorder() {
        this.cancelPreorderEmitter.emit(true);
    }
    editPayment() {
        this.editPaymentEmitter.emit(true);
    }
}
exports.CSPreOrderHeaderComponent = CSPreOrderHeaderComponent;
//# sourceMappingURL=preorder-header.component.js.map